import React, { forwardRef, useImperativeHandle, useRef } from 'react';

const FilePicker = forwardRef(function FilePicker({ multiple = true, accept, onPick, disabled = false }, ref) {
  const inputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    open: () => {
      if (disabled) return;
      inputRef.current?.click?.();
    },
    clear: () => {
      if (inputRef.current) inputRef.current.value = '';
    },
  }));

  const handleChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    onPick?.(files);

    e.target.value = '';
  };

  return (
    <input
      ref={inputRef}
      type='file'
      style={{ display: 'none' }}
      multiple={multiple}
      accept={accept}
      disabled={disabled}
      onChange={handleChange}
    />
  );
});

export default FilePicker;
